module.exports = __webpack_public_path__ + "img/icon-esim-detail-error-text-field-light.5d7836f.svg";